const Shimmer = () => {
  return (
    <div className="flex justify-center items-center flex-wrap mx-auto mt-20">
      <div className="h-[330px] w-[275px] bg-gray-200 m-5 rounded-md"></div>
      <div className="h-[330px] w-[275px] bg-gray-200 m-5 rounded-md"></div>
      <div className="h-[330px] w-[275px] bg-gray-200 m-5 rounded-md"></div>
      <div className="h-[330px] w-[275px] bg-gray-200 m-5 rounded-md"></div>
      <div className="h-[330px] w-[275px] bg-gray-200 m-5 rounded-md"></div>
      <div className="h-[330px] w-[275px] bg-gray-200 m-5 rounded-md"></div>
      <div className="h-[330px] w-[275px] bg-gray-200 m-5 rounded-md"></div>
      <div className="h-[330px] w-[275px] bg-gray-200 m-5 rounded-md"></div>
      <div className="h-[330px] w-[275px] bg-gray-200 m-5 rounded-md"></div>
      <div className="h-[330px] w-[275px] bg-gray-200 m-5 rounded-md"></div>
      <div className="h-[330px] w-[275px] bg-gray-200 m-5 rounded-md"></div>
      <div className="h-[330px] w-[275px] bg-gray-200 m-5 rounded-md"></div>
      <div className="h-[330px] w-[275px] bg-gray-200 m-5 rounded-md"></div>
      <div className="h-[330px] w-[275px] bg-gray-200 m-5 rounded-md"></div>
      <div className="h-[330px] w-[275px] bg-gray-200 m-5 rounded-md"></div>
      <div className="h-[330px] w-[275px] bg-gray-200 m-5 rounded-md"></div>
      <div className="h-[330px] w-[275px] bg-gray-200 m-5 rounded-md"></div>
      <div className="h-[330px] w-[275px] bg-gray-200 m-5 rounded-md"></div>
      <div className="h-[330px] w-[275px] bg-gray-200 m-5 rounded-md"></div>
      <div className="h-[330px] w-[275px] bg-gray-200 m-5 rounded-md"></div>
    </div>
  );
};

export default Shimmer;
